<template>
  <div class="cadre-arch-diagram">
    <h3 class="cadre-arch-diagram__title">{{ architecture.title }}</h3>
    <div class="cadre-arch-diagram__body">
      <aside class="cadre-arch-diagram__sources">
        <h4>{{ architecture.dataSources.title }}</h4>
        <ul class="cadre-arch-diagram__source-list">
          <li v-for="item in architecture.dataSources.items" :key="item.label">
            <span :class="['cadre-arch-diagram__source-icon', `cadre-arch-diagram__source-icon--${item.type}`]">
              {{ sourceIcon(item.type) }}
            </span>
            <span>{{ item.label }}</span>
          </li>
        </ul>
        <div class="cadre-arch-diagram__flow">
          <span>{{ architecture.dataSources.flow }}</span>
        </div>
      </aside>

      <div class="cadre-arch-diagram__center">
        <div class="cadre-arch-diagram__ai">
          <div
            v-for="feature in architecture.aiFeatures"
            :key="feature.title"
            class="cadre-arch-diagram__ai-box"
          >
            <h5>{{ feature.title }}</h5>
            <p v-for="item in feature.items" :key="item">{{ item }}</p>
          </div>
        </div>

        <div class="cadre-arch-diagram__db">
          <div class="cadre-arch-diagram__db-icon" aria-hidden="true">
            <span class="cadre-arch-diagram__db-top"></span>
            <span class="cadre-arch-diagram__db-body"></span>
          </div>
          <h4>{{ architecture.database.title }}</h4>
          <p>{{ architecture.database.desc }}</p>
        </div>

        <div class="cadre-arch-diagram__modules">
          <div
            v-for="mod in architecture.modules"
            :key="mod.title"
            class="cadre-arch-diagram__module"
          >
            <h5>{{ mod.title }}</h5>
            <p v-for="item in mod.items" :key="item">{{ item }}</p>
          </div>
        </div>
      </div>

      <aside class="cadre-arch-diagram__app">
        <div class="cadre-arch-diagram__export">{{ architecture.app.exportLabel }}</div>
        <h4>{{ architecture.app.title }}</h4>
        <div class="cadre-arch-diagram__app-grid">
          <div
            v-for="feature in architecture.app.features"
            :key="feature.label"
            class="cadre-arch-diagram__app-item"
          >
            <span class="cadre-arch-diagram__app-icon">{{ feature.icon }}</span>
            <span>{{ feature.label }}</span>
          </div>
        </div>
      </aside>
    </div>
    <p v-if="architecture.footer" class="cadre-arch-diagram__footer">{{ architecture.footer }}</p>
  </div>
</template>

<script>
export default {
  name: 'CadreArchDiagram',
  props: {
    architecture: {
      type: Object,
      required: true
    }
  },
  methods: {
    sourceIcon(type) {
      const icons = {
        zzb: '组',
        word: 'W',
        excel: 'E',
        ppt: 'P',
        text: 'T'
      }
      return icons[type] || '·'
    }
  }
}
</script>

<style scoped>
.cadre-arch-diagram {
  max-width: 1200px;
  margin: 0 auto;
  border: 1px solid #f0d0d0;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.cadre-arch-diagram__title {
  margin: 0;
  padding: 18px 24px;
  font-size: 22px;
  font-weight: 700;
  color: #c62828;
  text-align: center;
  border-bottom: 1px solid #f0d0d0;
}

.cadre-arch-diagram__body {
  display: grid;
  grid-template-columns: 190px 1fr 210px;
  gap: 0;
  background: #fff5f5;
}

.cadre-arch-diagram__sources,
.cadre-arch-diagram__app {
  padding: 20px 16px;
  background: #fff;
}

.cadre-arch-diagram__sources {
  border-right: 1px solid #f0d0d0;
  display: flex;
  flex-direction: column;
}

.cadre-arch-diagram__app {
  border-left: 1px dashed #ef5350;
  display: flex;
  flex-direction: column;
}

.cadre-arch-diagram__sources h4,
.cadre-arch-diagram__app h4 {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 700;
  color: #c62828;
  text-align: center;
  line-height: 1.4;
}

.cadre-arch-diagram__source-list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cadre-arch-diagram__source-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: #444;
  line-height: 1.4;
}

.cadre-arch-diagram__source-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
}

.cadre-arch-diagram__source-icon--zzb { background: #c62828; }
.cadre-arch-diagram__source-icon--word { background: #2b579a; }
.cadre-arch-diagram__source-icon--excel { background: #217346; }
.cadre-arch-diagram__source-icon--ppt { background: #d24726; }
.cadre-arch-diagram__source-icon--text { background: #78909c; }

.cadre-arch-diagram__flow {
  margin-top: 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: #c62828;
  padding: 8px;
  border: 1px dashed #ef9a9a;
  border-radius: 4px;
  background: #fff5f5;
}

.cadre-arch-diagram__center {
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.cadre-arch-diagram__ai {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.cadre-arch-diagram__ai-box {
  border: 1px dashed #5c9fd4;
  border-radius: 4px;
  padding: 12px 10px;
  background: rgba(255, 255, 255, 0.85);
  text-align: center;
}

.cadre-arch-diagram__ai-box h5,
.cadre-arch-diagram__module h5 {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 700;
  color: #c62828;
}

.cadre-arch-diagram__ai-box p,
.cadre-arch-diagram__module p {
  margin: 0 0 4px;
  font-size: 12px;
  color: #555;
  line-height: 1.45;
}

.cadre-arch-diagram__db {
  text-align: center;
  padding: 8px 0;
}

.cadre-arch-diagram__db-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}

.cadre-arch-diagram__db-top {
  width: 100px;
  height: 22px;
  background: linear-gradient(180deg, #ef5350, #c62828);
  border-radius: 50% / 100% 100% 0 0;
  border: 2px solid #b71c1c;
  border-bottom: none;
}

.cadre-arch-diagram__db-body {
  width: 100px;
  height: 72px;
  background: linear-gradient(90deg, #e53935, #ef5350 30%, #ffcdd2 50%, #ef5350 70%, #c62828);
  border: 2px solid #b71c1c;
  border-top: none;
  border-radius: 0 0 8px 8px;
}

.cadre-arch-diagram__db h4 {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
  color: #c62828;
}

.cadre-arch-diagram__db > p {
  margin: 0;
  font-size: 13px;
  color: #666;
}

.cadre-arch-diagram__modules {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.cadre-arch-diagram__module {
  background: #fff;
  border: 1px solid #ef9a9a;
  border-radius: 4px;
  padding: 12px 8px;
  text-align: center;
}

.cadre-arch-diagram__export {
  font-size: 12px;
  font-weight: 700;
  color: #c62828;
  text-align: center;
  margin-bottom: 12px;
  padding: 6px 8px;
  border: 1px dashed #ef9a9a;
  border-radius: 4px;
  background: #fff5f5;
}

.cadre-arch-diagram__app-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  flex: 1;
}

.cadre-arch-diagram__app-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 10px 6px;
  background: #fff5f5;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  font-size: 11px;
  color: #444;
  text-align: center;
  line-height: 1.35;
}

.cadre-arch-diagram__app-icon {
  font-size: 22px;
  line-height: 1;
}

.cadre-arch-diagram__footer {
  margin: 0;
  padding: 16px 24px;
  text-align: center;
  font-size: 14px;
  color: #888;
  border-top: 1px solid #f0d0d0;
  background: #fff;
}

@media (max-width: 960px) {
  .cadre-arch-diagram__body {
    grid-template-columns: 1fr;
  }

  .cadre-arch-diagram__sources {
    border-right: none;
    border-bottom: 1px solid #f0d0d0;
  }

  .cadre-arch-diagram__app {
    border-left: none;
    border-top: 1px dashed #ef5350;
  }

  .cadre-arch-diagram__ai {
    grid-template-columns: 1fr;
  }

  .cadre-arch-diagram__modules {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .cadre-arch-diagram__modules {
    grid-template-columns: 1fr;
  }
}
</style>
